"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
exports.default = vue_1.default.extend({
    name: 'UndergroundToken',
    props: {
        token: {
            type: Object,
        },
        location: {
            type: String,
        },
    },
    computed: {
        wrapper() {
            return 'underground-token-wrapper--' + this.location;
        },
        border() {
            return this.token.active ? 'underground-token-border' : '';
        },
        style() {
            return 'underground-token-style--' + this.location;
        },
        tokenClass() {
            return 'underground-token--' + this.token.token;
        },
        shelter() {
            return this.token.shelter ? 'underground-token-shelter' : '';
        },
    },
});
